import Wrapper from '@app/Wrapper.js'

Munio.AdminDashboard = class extends Wrapper {
  component() {
    return import('./Dashboard.vue')
  }
}
